module.exports = __webpack_public_path__ + "cc60d4b8d0fa8b0f1702597690d6897f.svg";